import React from 'react';
import TitleBase from './TitleBase';
import { TTitle } from './types';

const Title5 = ({ as = 'h5', ...rest }: TTitle) => <TitleBase {...rest} as={as} kind="title-5" />;

export default Title5;
